/**
 * Current language. One job.
 *
 * A module-level store rather than React state, because the batching loader needs to
 * read it from outside a component.
 */
import { useSyncExternalStore } from 'react';
import { Lang, DEFAULT_LANG } from '@framework/core';

let current: Lang = DEFAULT_LANG;
const listeners = new Set<() => void>();

export const getLang = (): Lang => current;

export function setLang(lang: Lang): void {
  if (lang === current) return;
  current = lang;
  document.documentElement.lang = lang;   // keeps <html lang> honest for screen readers
  listeners.forEach((l) => l());
}

export const useLang = (): Lang =>
  useSyncExternalStore(
    (cb) => { listeners.add(cb); return () => listeners.delete(cb); },
    getLang,
    () => DEFAULT_LANG,
  );
